import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";

// Google Ads tag (gtag.js) - AW-17926276899
declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}
(function loadGoogleAdsTag() {
  // Evita duplicarlo si ya existe
  if (document.querySelector('script[src*="googletagmanager.com/gtag/js?id=AW-17926276899"]')) return;

  // 1) Carga gtag.js
  const s1 = document.createElement("script");
  s1.async = true;
  s1.src = "https://www.googletagmanager.com/gtag/js?id=AW-17926276899";
  document.head.appendChild(s1);

  // 2) Inicializa dataLayer + gtag + config
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer!.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", "AW-17926276899");
})();
render(<App data-id="element-10" />, document.getElementById("root"));